import React from 'react';
import { useSelector } from 'react-redux';
import { Search } from 'semantic-ui-react';
import { hocSinhApi } from '../../api/hocSinhApi';
import { RootState } from '../../state/reducers';
import "./StudentSearch.module.css";
const initialState = {
    loading: false,
    results: [],
    value: '',
}

const search_reducer = (state: any, action: any) => {
    switch (action.type) {
        case 'CLEAN_QUERY':
            return initialState
        case 'START_SEARCH':
            return { ...state, loading: true, value: action.query }
        case 'FINISH_SEARCH':
            return { ...state, loading: false, results: action.results }
        case 'UPDATE_SELECTION':
            return { ...state, value: action.selection }

        default:
            throw new Error()
    }
}

const SearchHocsinh =  ({ dm_truong_id, onResultChanged, className, defaultValue }: any) => {
    const [state, dispatch] = React.useReducer(search_reducer, {
        ...initialState,
        value: defaultValue || ''
    })
    const { loading, results, value } = state
    const { dm_coso_id } = useSelector((state: RootState) => state.common)
    const { nam_hoc } = useSelector((state: RootState) => state.common)

    const timeoutRef = React.useRef<any>()
    const handleSearchChange = React.useCallback((e: any, data: any) => {
        clearTimeout(timeoutRef.current)
        dispatch({ type: 'START_SEARCH', query: data.value })

        timeoutRef.current = setTimeout(() => {
            if (data.value.length === 0) {
                dispatch({ type: 'CLEAN_QUERY' })
                return
            }
            (async () => {
                const res = await hocSinhApi.search({ dm_truong_id: dm_truong_id, key: data.value, dm_coso_id, nam_hoc });
                if (res.is_success) {
                    dispatch({
                        type: 'FINISH_SEARCH',
                        results: res.data.map((x: any) => {
                            return {
                                title: ((x.ma_hs != "" || x.ma_tn != "") ? "[" + (x.ma_hs != "" ? x.ma_hs : x.ma_tn) + "] - " : "") + x.ho_ten,
                                ho_ten: x.ho_ten,
                                ma_hs: x.ma_hs,
                                id: x.id,
                                ngay_sinh: x.ngay_sinh,
                                email: x.email_lien_he,
                                dien_thoai: x.dien_thoai_lien_he,
                                ten_khoi: x.ten_khoi,
                                ten_he: x.ten_he,
                                ten_truong: x.ten_truong,
                                ma_tn: x.ma_tn,
                                dm_he_id: x.dm_he_id,
                                dm_truong_id: x.dm_truong_id,
                                dm_khoi_id: x.dm_khoi_id,
                                nam_nhap_hoc: x.nam_nhap_hoc,
                                ten_lop: x.ten_lop
                            };
                        }),
                    })
                }
            })();

        }, 500)
    }, [dm_truong_id])
    React.useEffect(() => {
        return () => {
            clearTimeout(timeoutRef.current)
        }
    }, [])
    React.useEffect(() => {
        if (defaultValue == undefined) {
            dispatch({ type: 'CLEAN_QUERY' });
            return () => {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [dm_truong_id])
    const resultRenderer = (hocsinh: any): React.ReactElement<any> => {
        return (
            <React.Fragment>
                <div className="content">
                    <div className="price">{hocsinh.ma_hs ? hocsinh.ma_hs : hocsinh.ma_tn}</div>
                    <div className="title">{hocsinh.ho_ten}</div>
                    <div className="description">{hocsinh.ten_he} - {hocsinh.ten_khoi} - {hocsinh.ten_lop}</div>
                </div>
            </React.Fragment>
        );
    }
    return (
        <Search
            loading={loading}
            onResultSelect={(e, data) => {
                dispatch({ type: 'UPDATE_SELECTION', selection: data.result.title });
                onResultChanged(data.result);
            }
            }
            onSearchChange={handleSearchChange}
            results={results}
            resultRenderer={resultRenderer}
            value={value}
            input={{ icon: 'search', placeholder: 'Tìm theo mã hoặc họ tên' }}
            fluid={true}
            className={`student_search ${className ? className : ""}`}
        ></Search>
    )
}
export default SearchHocsinh;